import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { bskReq, currentSelectedBsk, findItem } from '@core/_utils/tools.utils';
import { EditorService } from './editor.service';
import { Tools } from './tools';
import { bsk_mailaction, bsk_mailconf, bsk_maillimit, bsk_mailurgent } from '@documalis/_const/const';

@Injectable()
export class BasketService {

    private currentSelectedBsk: currentSelectedBsk;
    private bskListCount: any[];
    public currentIdReqentete: number;
    public currentFilterId: number;
    public currentFilterAuto: boolean;
    public delay;
    public listRequest: any;
    public getFilterList: boolean;
    public filterNameOk: boolean;
    public currentfilterName: string = '';
    public currentFilterParam: any;
    public useFilter: boolean = false;
    private bsk_mailaction: typeof bsk_mailaction;
    private bsk_mailurgent: typeof bsk_mailurgent;
    private bsk_mailconf: typeof bsk_mailconf;
    private bsk_maillimit: typeof bsk_maillimit;

    constructor(
        public editorService: EditorService,
        public tools: Tools,
        private translate: TranslateService
    ) {
        this.bsk_mailaction = bsk_mailaction;
        this.bsk_mailurgent = bsk_mailurgent;
        this.bsk_mailconf = bsk_mailconf;
        this.bsk_maillimit = bsk_maillimit;
    }

    public clear() {
    }

    public initialize(aCurrentSelectedBsk, aBskListCount
        ) {
        this.currentSelectedBsk = aCurrentSelectedBsk;
        this.bskListCount = aBskListCount;
    }


    public async verifyUserFilter(aBskName, aBskTypeSearch) {
        let wRes = false;
        let wResultFilter: any;
        this.currentFilterParam = [];
        this.listRequest = undefined;
        this.getFilterList = false;
        wResultFilter = await this.tools.filterBasket(aBskName);
        if (wResultFilter.res === true) {
            this.getFilterList = true;
            this.setResultFilter(wResultFilter.resultFilter);
            if (wResultFilter.listRequest !== undefined) {
                this.listRequest = {
                    requestList: this.getRequestList(wResultFilter.listRequest.requestList, aBskTypeSearch),
                    selectedRequestId: wResultFilter.listRequest.selectedRequestId,
                    listResult: wResultFilter.listResult,
                    idxResult: wResultFilter.idxResult,
                }
            }
            this.currentFilterParam = wResultFilter.resultFilter.currentFilterParam;
            wRes = true;
        }
        return wRes;
    }

    private setResultFilter(aResultFilter) {
        this.currentFilterId = aResultFilter.currentFilterId;
        this.currentIdReqentete = aResultFilter.currentIdReqentete;
        this.currentFilterAuto = aResultFilter.currentFilterAuto;
    }

    private getRequestList(aRequestList, aBskTypeSearch) {
        let warray = [];
        aRequestList.forEach(item => {
            // Bannette type mail : toutes les requêtes
            if (aBskTypeSearch === 'Mail') {
                warray.push(item);
            } else {
            // Autre bannette : on ne prend pas les requêtes type mail
                if (bskReq('name', item.webReqDetails) !== 'mail') {
                    warray.push(item);
                }
            }
        });
        return warray;    
    }

    public findFilterName() {
        let wIndex = -1;
        this.filterNameOk = false;
        this.currentfilterName = '';
        if (this.listRequest !== undefined) {
            wIndex = findItem(this.listRequest.requestList, this.currentIdReqentete, 'id');
            if (wIndex !== -1) {
                this.filterNameOk = true;
                this.currentfilterName = this.listRequest.requestList[wIndex].label;
            }
        }   
    }

    private getResultList() {
        let wIndex = -1;
        let wRes = [];
        if (this.listRequest.idxResult !== -1) {
            wIndex = findItem(this.listRequest.listResult, this.listRequest.idxResult, 'id');
            if (wIndex !== -1) {
                wRes = this.getDisplayList(wIndex, false);
            }
        }
        if (this.useFilter === false) {
            return wRes;
        }
        wIndex = findItem(this.listRequest.requestList, this.currentIdReqentete, 'id');
        if (wIndex === -1) {
            return wRes;            
        }
        if (this.listRequest.requestList[wIndex].idResult === null || this.listRequest.requestList[wIndex].idResult === undefined) {
            return wRes;
        }
        wIndex = findItem(this.listRequest.listResult, this.listRequest.requestList[wIndex].idResult, 'id');
        if (wIndex === -1) {
            return wRes;    
        }
        if (this.listRequest.idxResult !== wIndex) {
            wRes = [...this.getDisplayList(wIndex, true)];
        }
        return wRes;
    }

    private getDisplayList(aIndex, aSort) {
        let wRes = [];
        let wSort = -1;
        let wTypeorder = 0;
        let wIsBskReq = '';
        let wFieldMail = false;
        wIsBskReq = bskReq('name', this.listRequest.listResult[aIndex].webResultDetails);
        if (wIsBskReq === 'mail' && this.currentSelectedBsk.bskType === 'btMail') {
            wFieldMail = true;
        }
        this.listRequest.listResult[aIndex].webResultDetails.forEach(item => {
            if (wFieldMail === false && this.isFieldMail(item.name) === true) {
                return;
            }
            if (aSort === true) {
                wSort = item.numorder;
                wTypeorder = item.typeorder;
            } else {
                wSort = -1;
                wTypeorder = 0;
            }
            wRes.push({
                name: item.name,
                type: item.type,
                label: item.label,
                sort: wSort,
                typeorder: wTypeorder,
                thumbinfo: item.thumbinfo,
            });            
        });
        return wRes;
    }

    private isFieldMail(aField) {
        let wRes = false;
        if (aField === this.bsk_mailaction.name || aField === this.bsk_mailurgent.name || aField === this.bsk_mailconf.name || aField === this.bsk_maillimit.name) {
            wRes = true;
        }
        return wRes;
    }

    public async execSelectBasket(aVariableList, aUpdateFilter, aVariableFilter, aCurrentFilterAuto, aEmptyField, aSearchWord) {
        let wRes: any;
        wRes = await this.tools.execSelectBasket(
            aUpdateFilter,
            aCurrentFilterAuto,
            this.editorService,
            this.currentFilterId,
            this.currentSelectedBsk,
            this.currentIdReqentete,
            aVariableFilter,
            aVariableList,
            this.bskListCount,
            this.delay,
            aEmptyField,
            aSearchWord,
            this.translate,
            this.getResultList()
        );
        return wRes;
    }

}
